import { makeStyles } from 'tss-react/mui';

type StyleParams = {
  isM1Enabled: boolean;
};

/**
 * Styles for the scrollable message list inside `AISidekickPanel`.
 *
 * The container takes the full vertical space the panel grants it
 * (`flex: 1`) and scrolls vertically. Horizontal overflow is hidden
 * because nothing in the chat surface should ever produce sideways
 * overflow. It is positioned so the visually hidden live regions inside
 * it stay clipped here instead of stretching the panel that hosts it.
 */
const useStyles = makeStyles<StyleParams>()((theme, { isM1Enabled }) => {
  return {
    scrollContainer: {
      position: 'relative',
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
      padding: `0 ${
        isM1Enabled ? theme.new.spacing.large : theme.new.spacing.medium
      } ${isM1Enabled ? theme.new.spacing.large : theme.new.spacing.medium}`,
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      gap: isM1Enabled ? 40 : theme.new.spacing.large,
      paddingTop: isM1Enabled ? 0 : theme.new.spacing.medium,
    },
    thinkingSlot: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    endAnchor: {
      width: '100%',
      height: 1,
    },
    visuallyHidden: {
      position: 'absolute',
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0,
    },
  };
});

export default useStyles;
